var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParticipantLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  fill: "none",
  viewBox: "0 0 44 44"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 17.5,
  stroke: "#F7F7FA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.6 30.4q.6.6 1.416.6h13.968q.84 0 1.428-.6T31 28.984V27h-2.016v1.984H15.016V15.016h13.968V17H31v-1.984q0-.816-.588-1.416t-1.428-.6H15.016q-.816 0-1.416.6t-.6 1.416v13.968q0 .816.6 1.416"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M25.08 25.616 27.648 23H18v-1.968h9.648l-2.568-2.616L26.496 17l5.016 5.016-5.016 5.016z",
  clipRule: "evenodd"
})));
export default SvgParticipantLeft;